import commonUtils from "@/utils/common.utils";
import store from "../store/store";
import auth from "@/utils/auth.utils";

const authGuard = async (to, from, next) => {
  try {
    console.log("to", to.params);
    console.log("from", from.params);
    // 沒有 token 保持未登錄狀態停留在該頁面
    if (!store.getters['userData/accessToken']) {
      next()
      return
    }
    // 如果 token 過期則安靜登出，停留在該頁面
    if (!store.getters['userData/isLogin']) {
      auth.logout();
      next()
      return
    }

    const currentStore = store.getters["userData/storeCode"];
    if (to.params.store !== currentStore) {
      await store.dispatch('userData/changeStore', {
        store_code: to.params.store
      })
      store.commit('cart/setCart', [])
      store.commit('cart/setSelectedCoupon', null)
      store.commit('cart/setTableData', {})
      store.commit('cart/setTakeOutTableData', {})
      store.commit("cart/setPayment", {})
      store.commit('userData/setMemberInfo', {})
    }

    await store.dispatch('basic/fetchStoreServicesList')

    // 只需攔截後台是否有購買線上點餐功能
    if (!store.getters['basic/isServiceEnabled'](1)) throw ('線上點餐暫停接單中')
    next();
  } catch (error) {
    let errorMessage = error
    if (errorMessage == 'No Such Store') errorMessage = '查無此店家'
    commonUtils.createToast('error', errorMessage)
    console.error("table order guard error", error);
    next({ path: `/${to.params.store}` });
  }
};

export default authGuard;
